import { gql, useQuery } from "@apollo/client";
import React from "react";
import { animated, useSpring } from "react-spring";
import { useTitle } from "react-use";
import Spinner from "../../components/Spinner";
import { UserQuery } from "../../store/models/users";
// import * as r from "../../routes";
import "./Home.scss";

const FETCH_USER_SELF = gql`
  query userSelf {
    userSelf {
      fullName
      firstName
    }
  }
`;

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  useTitle("Home | Due");
  // const dispatch = useDispatch();
  const { loading, error, data } = useQuery<UserQuery>(FETCH_USER_SELF);

  const props = useSpring({ opacity: loading ? 0 : 1 });

  if (loading || !data) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error) {
    <div className="w-full h-full flex items-center justify-center">Error</div>;
  }

  // const {
  //   userSelf: { firstName },
  // } = data;

  return (
    <animated.div style={props as any} className="w-full h-full">
      {/* <div className="flex w-1/2"></div>
      <div className="w-1/2 prose prose-lg">
        <h1> Welcome, {firstName}.</h1>
        <p className="lead">
          Thank you for signing up and joining the wait list. We are currently
          still in development. But by signing up we will notify you first thing
          when we are up and operational.
        </p>
      </div> */}

      {/* <Box
        align="start"
        direction="row"
        width="1150px"
        gap="medium"
        pad={{ top: "small" }}
      >
        <Box margin={{ bottom: "large" }}>
          {accounts.map((account) => {
            return <AccountInfo key={account.id} account={account} />;
          })}
          {accounts.length === 0 && (
            <Card pad="medium" width="600px" background="white" align="center">
              {!loading && (
                <>
                  <Heading
                    margin={{ top: "small", bottom: "medium" }}
                    level="3"
                  >
                    Let's get start by creating an Account!
                  </Heading>
                  <Link to={ROUTE_ACCOUNT}>
                    <Button primary label="Create Account" />
                  </Link>
                </>
              )}
              {loading && (
                <Box align="center" justify="center" pad="large">
                  <Spinner />
                </Box>
              )}
            </Card>
          )}
          <Card
            pad="medium"
            width="600px"
            background="white"
            margin={{ top: "medium" }}
            direction="row"
          >
            <Box style={{ minWidth: 48 }}>
              <Sun color="brand" size="large" />
            </Box>
            <Box margin={{ left: "small" }}>
              <Heading level="4">Prepare for you future.</Heading>
              <Paragraph fill size="small" color="dark-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Paragraph>
              <Anchor size="small">Learn more.</Anchor>
            </Box>
          </Card>

          <Card
            pad="medium"
            width="600px"
            background="white"
            margin={{ top: "medium" }}
            direction="row"
          >
            <Box style={{ minWidth: 48 }}>
              <Info color="brand" size="large" />
            </Box>
            <Box margin={{ left: "small" }}>
              <Heading level="4">Tips and tricks for retirement.</Heading>
              <Paragraph fill size="small" color="dark-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Paragraph>
              <Anchor size="small">Learn more.</Anchor>
            </Box>
          </Card>
        </Box>
        <Box direction="row" gap="medium" flex align="start">
          <Box gap="medium">
            <Card pad="medium" background="white" flex>
              <Text weight="bold" margin={{ bottom: "small" }}>
                Contribution Summary
              </Text>
              <Text size="xsmall" color="brand">
                Premium (Joint)
              </Text>
              <Text size="large">Retirement</Text>
              <Text size="small">$60/month</Text>
            </Card>

            <Card pad="medium" background="white" flex>
              <Text weight="bold" margin={{ bottom: "small" }}>
                Recent Transactions
              </Text>
              <Box direction="row" margin={{ bottom: "small" }}>
                <Box>
                  <Text size="small">Deposit</Text>
                  <Text size="xsmall" color="dark-4">
                    Retirement
                  </Text>
                </Box>
                <Box className="ml-auto">
                  <Text size="small">$600.00</Text>
                </Box>
              </Box>

              <Box direction="row" margin={{ bottom: "small" }}>
                <Box>
                  <Text size="small">Monthly Deposit</Text>
                  <Text size="xsmall" color="dark-4">
                    Retirement
                  </Text>
                </Box>
                <Box className="ml-auto">
                  <Text size="small">$60.00</Text>
                </Box>
              </Box>

              <Box direction="row" margin={{ bottom: "small" }}>
                <Box>
                  <Text size="small">Deposit</Text>
                  <Text size="xsmall" color="dark-4">
                    Retirement
                  </Text>
                </Box>
                <Box className="ml-auto">
                  <Text size="small">$200.00</Text>
                </Box>
              </Box>

              <Box direction="row" margin={{ bottom: "small" }}>
                <Anchor size="small">See all transactions</Anchor>
              </Box>
            </Card>
          </Box>

          <Card pad="medium" background="white" flex align="center">
            <Text weight="bold" size="large">
              Refer a Friend!
            </Text>
            <Text size="small" color="dark-5">
              Earn $100 Per Referral
            </Text>
            <Send size="xlarge" />

            <Anchor label="Learn More"></Anchor>
          </Card>
        </Box>
      </Box> */}
    </animated.div>
  );
};

export default Home;
